exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-alert[data-v-90ac6dbc]{padding:0 15px;border-radius:5px}.alert-comp[data-v-90ac6dbc]{background-color:#e0e3e5;border-color:#e0e3e5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-90ac6dbc","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/order/UserOrderStatus.vue
// module id = mHxS
// module chunks = 1